__turbopack_context__.v({
  "avatarFallback": "Avatar-module-scss-module__6zdHjW__avatarFallback",
  "avatarImage": "Avatar-module-scss-module__6zdHjW__avatarImage",
  "avatarWrapper": "Avatar-module-scss-module__6zdHjW__avatarWrapper",
});
